import {
  Text,
  GreyGrey80,
  Primary13Regular,
  useNotifications,
  SimpleModal
} from '@sequencehq/core-components'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useMutation } from '@sequencehq/api'

type Props = {
  creditNoteId: string
  isOpen: boolean
  onClose: () => void
  onSuccess?: () => void
}

export const VoidCreditNoteDialog = ({
  creditNoteId,
  isOpen,
  onClose,
  onSuccess
}: Props) => {
  const voidCreditNote = useVoidCreditNote()

  const handleSubmit = async () => {
    const result = await voidCreditNote({ creditNoteId })

    if (!result) {
      return false
    }

    onSuccess?.()
    return true
  }

  return (
    <SimpleModal
      data-testid="modal.voidCreditNote"
      variant="dialog"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Void credit note"
      submitButtonText="Void credit note"
      submittingButtonText="Voiding..."
      isDestructive
    >
      <Text {...Primary13Regular} color={GreyGrey80}>
        You won't be able to make any further changes to this credit note after
        voiding.
      </Text>
    </SimpleModal>
  )
}

const useVoidCreditNote = () => {
  const { displayNotification } = useNotifications()
  const { mutateAsync: voidCreditNote } = useMutation(
    dashboardv99990101Client.postVoidCreditNote
  )

  return async (input: { creditNoteId: string }) => {
    try {
      const voidedCreditNote = await voidCreditNote({ id: input.creditNoteId })

      if (voidedCreditNote === null) {
        displayNotification('Failed to void credit note', {
          type: 'error'
        })
        return
      }

      displayNotification(
        `Credit note ${voidedCreditNote.creditNoteNumber} marked as void`,
        {
          type: 'success'
        }
      )

      return voidedCreditNote
    } catch {
      displayNotification('Failed to void credit note', {
        type: 'error'
      })
      return
    }
  }
}
